import { format } from "date-fns";
import { englishDateParts } from "./dateParts";

/** Shown for a result whose stored date cannot be read. */
const NO_DATE = "—";
const isValid = (date: Date) => Number.isFinite(date.getTime());

/** "12 Aug" this year, "12 Aug 2025" otherwise, on the athlete's own calendar. */
export function formatResultDay(date: Date, now: Date = new Date()): string {
  if (!isValid(date)) return NO_DATE;
  if (date.getFullYear() !== now.getFullYear()) return formatResultDate(date);
  const p = englishDateParts(date, { day: "numeric", month: "short" });
  return `${p.day} ${p.month}`;
}

/** "14 Sep 2026": a result's date where the year always shows (tables, charts). */
export function formatResultDate(date: Date): string {
  if (!isValid(date)) return NO_DATE;
  const p = englishDateParts(date, { day: "numeric", month: "short", year: "numeric" });
  return `${p.day} ${p.month} ${p.year}`;
}

/** The same for epoch ms, where 0 is how `toEpochMs` says "no date". */
export function formatResultDateMs(ms: number): string {
  return ms > 0 ? formatResultDate(new Date(ms)) : NO_DATE;
}

/** "2026-10-03": the athlete's own calendar day, as `<input type="date">` reads and writes it. */
export function toInputDate(ms: number): string {
  return format(new Date(ms), "yyyy-MM-dd");
}
